import { createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createBlock as _createBlock, Fragment as _Fragment, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-14a4aff6"),n=n(),_popScopeId(),n)
const _hoisted_1 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h4", null, [
  /*#__PURE__*/_createTextVNode("Hat die antragstellende Firma eine Muttergesellschaft oder"),
  /*#__PURE__*/_createElementVNode("br"),
  /*#__PURE__*/_createTextVNode(" ist das Unternehmen im Besitz eines anderen Unternehmens?")
], -1))
const _hoisted_2 = { key: 0 }
const _hoisted_3 = { key: 2 }
const _hoisted_4 = {
  key: 3,
  class: "form-control"
}
const _hoisted_5 = { key: 0 }
const _hoisted_6 = { key: 1 }
const _hoisted_7 = { key: 2 }
const _hoisted_8 = { key: 6 }
const _hoisted_9 = { key: 8 }
const _hoisted_10 = {
  key: 9,
  class: "form-control"
}
const _hoisted_11 = { key: 0 }
const _hoisted_12 = { key: 1 }
const _hoisted_13 = { key: 2 }
const _hoisted_14 = { class: "buttons" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_base_toggle = _resolveComponent("base-toggle")!
  const _component_request_base_company = _resolveComponent("request-base-company")!
  const _component_request_base_address = _resolveComponent("request-base-address")!
  const _component_base_button = _resolveComponent("base-button")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _hoisted_1,
    _createVNode(_component_base_toggle, {
      onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.changeValue1())),
      value: _ctx.value1,
      reverse: true,
      height: '28',
      width: '55',
      "font-size": '18',
      checkedDotColor: 'white',
      uncheckedDotColor: '#173166',
      checkedText: '',
      uncheckedText: '',
      checkedBg: '#173166',
      uncheckedBg: 'lightgrey'
    }, null, 8, ["value"]),
    (_ctx.value1)
      ? (_openBlock(), _createElementBlock("h4", _hoisted_2, "Konsolidiert die Muttergesellschaft den Jahresabschluss/Jahresbericht?"))
      : _createCommentVNode("", true),
    (_ctx.value1)
      ? (_openBlock(), _createBlock(_component_base_toggle, {
          key: 1,
          onClick: _ctx.changeValue2,
          value: _ctx.value2,
          reverse: true,
          height: '28',
          width: '55',
          "font-size": '18',
          checkedDotColor: 'white',
          uncheckedDotColor: '#173166',
          checkedText: '',
          uncheckedText: '',
          checkedBg: '#173166',
          uncheckedBg: 'lightgrey'
        }, null, 8, ["onClick", "value"]))
      : _createCommentVNode("", true),
    (_ctx.value2)
      ? (_openBlock(), _createElementBlock("h4", _hoisted_3, "Informationen über die Muttergesellschaft"))
      : _createCommentVNode("", true),
    (_ctx.value2)
      ? (_openBlock(), _createElementBlock("div", _hoisted_4, [
          (!_ctx.formParentCompanyValid)
            ? (_openBlock(), _createElementBlock("p", _hoisted_5, " Unternehmensdaten der Muttergesellschaft überprüfen"))
            : (!_ctx.formParentAddressValid)
              ? (_openBlock(), _createElementBlock("p", _hoisted_6, " Adressdaten der Muttergesellschaft überprüfen"))
              : (!_ctx.addressParentValid)
                ? (_openBlock(), _createElementBlock("p", _hoisted_7, " Adressdaten der Muttergesellschaft nicht gefunden"))
                : _createCommentVNode("", true)
        ]))
      : _createCommentVNode("", true),
    (_ctx.value2)
      ? (_openBlock(), _createBlock(_component_request_base_company, {
          key: 4,
          type: 'stepper-parent-company',
          onInterface: _ctx.getParentCompanyInterface,
          onValidForm: _ctx.validParentCompany
        }, null, 8, ["onInterface", "onValidForm"]))
      : _createCommentVNode("", true),
    (_ctx.value2)
      ? (_openBlock(), _createBlock(_component_request_base_address, {
          key: 5,
          type: 'stepper-parent-address',
          onInterface: _ctx.getAddressParentInterface,
          onValidForm: _ctx.validParentAddress
        }, null, 8, ["onInterface", "onValidForm"]))
      : _createCommentVNode("", true),
    (_ctx.value2)
      ? (_openBlock(), _createElementBlock("h4", _hoisted_8, "Steht die Muttergesellschaft auf oberster Ebene?"))
      : _createCommentVNode("", true),
    (_ctx.value2)
      ? (_openBlock(), _createBlock(_component_base_toggle, {
          key: 7,
          onClick: _cache[1] || (_cache[1] = ($event: any) => {_ctx.value3 = !_ctx.value3; }),
          value: _ctx.value3,
          reverse: true,
          height: '28',
          width: '55',
          "font-size": '18',
          checkedDotColor: 'white',
          uncheckedDotColor: '#173166',
          checkedText: '',
          uncheckedText: '',
          checkedBg: '#173166',
          uncheckedBg: 'lightgrey'
        }, null, 8, ["value"]))
      : _createCommentVNode("", true),
    (!_ctx.value3)
      ? (_openBlock(), _createElementBlock("h4", _hoisted_9, "Informationen über das oberste Mutterunternehmen"))
      : _createCommentVNode("", true),
    (!_ctx.value3)
      ? (_openBlock(), _createElementBlock("div", _hoisted_10, [
          (!_ctx.formMainCompanyValid)
            ? (_openBlock(), _createElementBlock("p", _hoisted_11, " Unternehmensdaten des obersten Mutterunternehmens überprüfen"))
            : (!_ctx.formMainAddressValid)
              ? (_openBlock(), _createElementBlock("p", _hoisted_12, " Adressdaten des obersten Mutterunternehmens überprüfen"))
              : (!_ctx.addressMainValid)
                ? (_openBlock(), _createElementBlock("p", _hoisted_13, " Adressdaten des obersten Mutterunternehmens nicht gefunden"))
                : _createCommentVNode("", true)
        ]))
      : _createCommentVNode("", true),
    (!_ctx.value3)
      ? (_openBlock(), _createBlock(_component_request_base_company, {
          key: 10,
          type: 'stepper-main-company',
          onInterface: _ctx.getMainCompanyInterface,
          onValidForm: _ctx.validMainCompany
        }, null, 8, ["onInterface", "onValidForm"]))
      : _createCommentVNode("", true),
    (!_ctx.value3)
      ? (_openBlock(), _createBlock(_component_request_base_address, {
          key: 11,
          type: 'stepper-main-address',
          onInterface: _ctx.getAddressMainInterface,
          onValidForm: _ctx.validMainAddress
        }, null, 8, ["onInterface", "onValidForm"]))
      : _createCommentVNode("", true),
    _createElementVNode("div", _hoisted_14, [
      _createVNode(_component_base_button, {
        title: 'Zurück',
        onClick: _ctx.backToAddress
      }, null, 8, ["onClick"]),
      _createVNode(_component_base_button, {
        title: 'Weiter',
        onClick: _ctx.submitParent
      }, null, 8, ["onClick"])
    ])
  ], 64))
}